import { useState, useCallback } from "react";
import type { SubscriptionTier } from "./useSubscription";

const STORAGE_KEY = "dev_plan_override";

export function getDevPlanOverride(): SubscriptionTier | null {
  const val = localStorage.getItem(STORAGE_KEY);
  if (val === "free" || val === "pro" || val === "scale" || val === "fleet") return val;
  return null;
}

export function useDevPlanOverride() {
  const [override, setOverrideState] = useState<SubscriptionTier | null>(getDevPlanOverride);

  const setOverride = useCallback((tier: SubscriptionTier | null) => {
    if (tier) {
      localStorage.setItem(STORAGE_KEY, tier);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    setOverrideState(tier);
    // Force full reload so all hooks pick up the change
    window.location.reload();
  }, []);

  return { override, setOverride };
}
